import { uniqBy } from 'lodash';
import { computed, Ref, ref, watch } from 'vue';
import { Permission } from '@infuse/iam/permission/domain';

export const usePermissionsSubscriptionFilter = (permissions: Ref<Permission[]>) => {
  const subscriptions = computed(() =>
    uniqBy(
      permissions.value.map((p) => ({ id: p.subscriptionId, name: p.subscriptionName })),
      'id'
    )
  );

  const activeSubscription = ref<{ id: string; name: string } | undefined>();

  watch(
    () => subscriptions.value,
    () => {
      // If the active subscription is not yet set, set it to the first subscription
      if (!activeSubscription.value) {
        activeSubscription.value = subscriptions.value[0];
      }
    },
    { immediate: true }
  );

  return { subscriptions, activeSubscription };
};
